import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import type { DashboardWidgetCustomConfig } from '../../../core/enums/dashboard-cards.enum';

export interface DashboardWidgetCustomizeDialogData {
  title: string;
  initial: DashboardWidgetCustomConfig | null;
}

@Component({
  standalone: true,
  selector: 'app-dashboard-widget-customize-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <h2 mat-dialog-title class="text-lg">{{ data.title }}</h2>
    <mat-dialog-content class="flex flex-col gap-3 min-w-[300px]">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Card title</mat-label>
        <input matInput name="cardTitle" [(ngModel)]="title" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Accent color (hex)</mat-label>
        <input matInput name="accent" [(ngModel)]="accentColor" placeholder="#AD46FF" />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2">
      <button mat-button type="button" (click)="clear()">Reset</button>
      <button mat-button mat-dialog-close type="button">Cancel</button>
      <button mat-flat-button color="primary" type="button" (click)="save()">
        Save
      </button>
    </mat-dialog-actions>
  `,
})
export class DashboardWidgetCustomizeDialogComponent {
  data = inject<DashboardWidgetCustomizeDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject(
    MatDialogRef<DashboardWidgetCustomizeDialogComponent>,
  );

  title = this.data.initial?.title ?? '';
  accentColor = this.data.initial?.accentColor ?? '';

  save(): void {
    const cfg: DashboardWidgetCustomConfig = {};
    if (this.title.trim()) cfg.title = this.title.trim();
    if (this.accentColor.trim()) cfg.accentColor = this.accentColor.trim();
    this.dialogRef.close(
      Object.keys(cfg).length ? cfg : null,
    );
  }

  clear(): void {
    this.dialogRef.close(null);
  }
}
